import { render, staticRenderFns } from "./AiSolution.vue?vue&type=template&id=7906b755&lang=pug"
import script from "./AiSolution.vue?vue&type=script&lang=js"
export * from "./AiSolution.vue?vue&type=script&lang=js"
import style0 from "./AiSolution.vue?vue&type=style&index=0&id=7906b755&prod&module=true&lang=scss"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports